import partyAHome from './partyAHome.js'

export default {
    partyAHome
}



// WEBPACK FOOTER //
// ./src/api/modules/partyA/index.js